export default "__VITE_ASSET__C5DJkD3G__"